/**
* Multi Page Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the multi page form template.
*/
( function( app ) {
  const COMPONENT = {

    className: 'template-multi-paged-form',


    selector: function() {
      return '.' + this.className;
    },


    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( sessionStorage.getItem( 'back-to-page' ) !== null ) {
        $( '.mpf-exit a' ).attr( 'href', sessionStorage.getItem( 'back-to-page' ) );
      }
      const _this = this;
      function mpfSetup() {
        $( this ).fadeToggle();
        $( '#template-mpf__intro-page' ).fadeToggle();
        setTimeout( function() {
          $( '#template-mpf__form' ).fadeToggle();
        }, 200 );
        $( '.llgq-progress-bar-inactive' ).addClass( 'llgq-progress-bar' );
        if ( $( '.llgq-progress-bar .llgq-progress' ).length ) {
          $( '.llgq-progress-bar .llgq-progress' ).css( {
            'width': '10%',
          } );
        }
      }
      if ( $( '.form-skin.mpf.skip-get-started' )[0] ) {
        mpfSetup();
      } else {
        $( '.mpf-start-button' ).on( 'click', function() {
          mpfSetup();
        } );
      }

      $( '.gform_next_button.btn-primary' ).each( function() {
        $( this ).outerHeight( '52px' );
        $( this ).outerWidth( '174.25px' );
        $( this ).find( 'span' ).addClass( 'loaded' );
      } );
      // Set Current Page
      $( '.gform_wrapper .gform_page:first-child' ).addClass( 'llgq-current-page' );

      // hide next button on radio page
      if ( $( '.gform_wrapper .gform_page:first-child' ).hasClass( 'llgq-radio-page' ) ) {
        $( '.llgq-current-page .gform_next_button, .llgq-quoter-next, .gform_button[type="submit"]' ).addClass( 'llgq-radio-page-hidden' );
      } else {
        $( '.llgq-current-page .gform_next_button, .llgq-quoter-next, .gform_button[type="submit"]' ).removeClass( 'llgq-radio-page-hidden' );
      }
      // when new page is loaded (not initial page)
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        valueChanged = false;

        $( '.btn-primary' ).each( function() {
          $( this ).outerHeight( '52px' );
          $( this ).outerWidth( '174.25px' );
          $( this ).find( 'span' ).addClass( 'loaded' );
        } );

        $( '.llgq-quoter-back' ).on( 'click', function() {
          $( '.llgq-current-page .gform_previous_button' ).trigger( 'click' );
        } );

        $( '.llgq-quoter-next' ).on( 'click', function() {
          if ( $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).length ) {
            $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).trigger( 'click' );
          } else {
            $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
          }
        } );

        // Add a class to the current page
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'llgq-current-page' );

        // Update quoter nav
        if ( currentPage > 1 ) {
          $( '.llgq-quoter-back' ).removeClass( 'is-inactive' );
        } else {
          $( '.llgq-quoter-back' ).addClass( 'is-inactive' );
        }

        if ( currentPage === $( '.gform_page' ).length ) {
          $( '.llgq-quoter-next' ).addClass( 'is-inactive' );
        } else {
          $( '.llgq-quoter-next' ).removeClass( 'is-inactive' );
        }

        // hide next button on radio page
        if ( $( '#gform_page_' + formId +'_' + currentPage ).hasClass( 'llgq-radio-page' ) ) {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next, .gform_button[type="submit"]' ).addClass( 'llgq-radio-page-hidden' );
        } else {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next, .gform_button[type="submit"]' ).removeClass( 'llgq-radio-page-hidden' );
        }

        // Scroll to top
        if ( !$( '#gform_' + formId ).hasClass( 'gform_disable_auto_scroll' ) ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        }
      } );

      // Hide custom progress bar on confirmation
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.llgq-progress-bar' ).hide();
        $( '.llgq-quoter-back, .llgq-quoter-next' ).hide();
        const mpfFormId = $( '#template-mpf__form' ).data( 'form-id' );
        if ( formId == mpfFormId ) {
          $( '#template-mpf__form' ).hide();
          $( '#template-mpf__intro-page' ).show();
          const confirmationText = $( '#gform_confirmation_message_'+mpfFormId ).html().replace( /<br>\\*/g, '' );
          $( '#template-mpf__intro-page-content' ).html( confirmationText );
        }
        $( '.btn-primary' ).each( function() {
          const btnHeight = $( this ).height();
          const btnWidth = $( this ).width();
          $( this ).height( btnHeight );
          $( this ).width( btnWidth );
          $( this ).find( 'span:first-of-type' ).addClass( 'loaded' );
        } );
      } );
    },


    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'multi-page-form', COMPONENT );
} )( app );
